import { connect } from "react-redux";
import { QuestionFooter as Component } from "./QuestionFooter";
import {
  submitQuestionAnswer,
  saveTaskNote,
} from "@learningblocks/protocol-redux/lib/Actions";

function mapStateToProps(state) {
  return {
    interactionProps: {
      solutions: Object.hasOwn(
        state.notebook.protocolSection.scene,
        "apparatus"
      )
        ? state.notebook.protocolSection.scene.apparatus.solutions
        : null,
    },
    DNAkey:
      Object.hasOwn(state.notebook.protocolSection.scene, "apparatus") &&
      Object.hasOwn(
        state.notebook.protocolSection.scene.apparatus,
        "solutions"
      ) &&
      state.notebook.protocolSection.scene.apparatus.solutions.length > 15
        ? Object.keys(
            state.notebook.protocolSection.scene.apparatus.solutions[14]
              .solutions
          )[0]
        : null,
    uuid: state.notebook.protocolSection.uuid,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    submitAnswer: (id, type, saveTaskNote) =>
      dispatch(submitQuestionAnswer(id, type, saveTaskNote)),
    saveTaskNote: (data) => dispatch(saveTaskNote(data)),
  };
}

export const QuestionFooter = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
